import React, { forwardRef } from 'react';
import { SnackbarContent, CustomContentProps, closeSnackbar } from 'notistack';
import { Icon } from '../../omni/icon';

export type TNotificationProps = CustomContentProps & {};

const Notification = forwardRef<HTMLDivElement, TNotificationProps>(
    ({ id, message, variant }, ref) => {
        const notificationType =
            variant === 'default'
                ? 'info'
                : variant === 'error'
                    ? 'danger'
                    : variant;
        const iconType =
            variant === 'default'
                ? 'info'
                : variant === 'warning'
                    ? 'alert'
                    : variant;

        const handleClose = () => {
            if (id) {
                closeSnackbar(id);
            }
        };

        return (
            <SnackbarContent
                ref={ref}
                role="alert"
                className={`notification is-${notificationType}`}>
                    <Icon icon-id={`omni:informative:${iconType}`}></Icon>
                    <div style={{ flex: 1 }}>{message}</div>
                    {variant === 'warning' && (
                        <div
                            onClick={handleClose}
                            aria-label="Close notification"
                        >
                            <Icon
                                icon-id="omni:interactive:close"
                                className="warning-close"
                            />
                        </div>
                    )}
            </SnackbarContent>
        );
    }
);

export default Notification;
